/**
 * ArchiMate Element Factory
 * Создание элементов и связей ArchiMate
 */

import { ARCHIMATE_ELEMENTS, getArchimateColors, ARCHIMATE_RELATIONSHIPS } from '../types/archimateElements';

let idCounter = 0;
const generateId = () => `archimate-${Date.now()}-${++idCounter}-${Math.random().toString(36).substr(2, 6)}`;

/**
 * Создать ArchiMate элемент
 */
export const createArchimateElement = (archimateType, x, y, width = 140, height = 70) => {
  const elementDef = ARCHIMATE_ELEMENTS[archimateType];
  if (!elementDef) {
    console.error('Unknown ArchiMate element type:', archimateType);
    return null;
  }

  const colors = getArchimateColors(elementDef.layer);

  return {
    id: generateId(),
    type: 'archimate',
    archimateType: archimateType,
    layer: elementDef.layer,
    shape: elementDef.shape,
    x,
    y,
    width,
    height,
    fill: colors.fill,
    stroke: colors.stroke,
    strokeWidth: colors.strokeWidth,
    content: elementDef.label,
    label: elementDef.label,
    selected: false,
    zIndex: 0
  };
};

/**
 * Создать ArchiMate связь
 */
export const createArchimateRelationship = (relationshipType, fromId, toId, x1, y1, x2, y2) => {
  const relationship = ARCHIMATE_RELATIONSHIPS[relationshipType];
  if (!relationship) {
    console.error('Unknown ArchiMate relationship type:', relationshipType);
    return null;
  }

  return {
    id: generateId(),
    type: 'archimate_relationship',
    relationshipType: relationshipType,
    fromElementId: fromId,
    toElementId: toId,
    x: x1,
    y: y1,
    x2: x2,
    y2: y2,
    stroke: '#000000',
    strokeWidth: 2,
    dashed: relationship.style === 'dashed',
    startCap: relationship.startCap,
    endCap: relationship.endCap,
    label: relationship.label,
    selected: false,
    zIndex: 0
  };
};

/**
 * Получить все типы элементов для слоя
 */
export const getElementTypesForLayer = (layer) => {
  return Object.entries(ARCHIMATE_ELEMENTS)
    .filter(([_, def]) => def.layer === layer)
    .map(([key, def]) => ({
      key,
      label: def.label,
      type: def.type,
      shape: def.shape
    }));
};

/**
 * Получить все типы связей
 */
export const getRelationshipTypes = () => {
  return Object.entries(ARCHIMATE_RELATIONSHIPS).map(([key, def]) => ({
    key,
    label: def.label,
    type: def.type,
    style: def.style
  }));
};
